module.exports = flarum.core.compat['components/SplitDropdown'];